<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('production_store.raw_material_purchase_manage') }}</h4>
          </template>
          <template v-slot:headerAction>
              <router-link to="raw-material-purchase-manage" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{  $t('production_store.purchase') + ' ' + $t('globalTrans.list') }}</router-link>
          </template>
          <template v-slot:body>
                <b-row>
                  <b-col lg="12" sm="12" class="text-center mb-4">
                      <h5 class='complain-title'>{{ $t('production_store.add_product') }}</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-overlay :show="priceLoad">
                      <ValidationObserver ref="formAddProduct" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(addProduct)" @reset.prevent="reset" >
                          <b-row>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Product Cagetory" vid="category_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="category_id"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.pro_category')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="singleProduct.category_id"
                                    :options="categoryList"
                                    id="category_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Sub-Cagetory" vid="sub_category_id" rules="">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="sub_category_id"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.pro_sub_category')}}
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="singleProduct.sub_category_id"
                                    :options="subCategoryList"
                                    id="sub_category_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Product" vid="product_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="product_id"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.pro_name')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="singleProduct.product_id"
                                    :options="productList"
                                    id="product_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Unit" vid="unit_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="unit_id"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.unit')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="singleProduct.unit_id"
                                    :options="unitList"
                                    id="unit_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Avaiable Quantity" vid="available_quantity" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="available_quantity"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.available_quantity')}}
                                  </template>
                                  <b-form-input
                                    id="available_quantity"
                                    readonly
                                    v-model="singleProduct.available_quantity"
                                    :placeholder="priceLoad ? `Loading...` : ``"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Unit price" vid="unit_price" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="unit_price"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.unit_price')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                  readonly
                                    id="unit_price"
                                    v-model="singleProduct.unit_price"
                                    :placeholder="priceLoad ? `Loading...` : ``"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Purchase quantity" vid="purchase_qty"  rules="required|numeric|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="purchase_qty"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.purchase_quantity')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                    v-model="singleProduct.purchase_qty"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="12">
                              <ValidationProvider name="Total Price" vid="total_price" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="total_price"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{$t('production_store.total_price')}}
                                  </template>
                                  <b-form-input
                                  readonly
                                    id="total_price"
                                    v-model="singleProduct.total_price"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                          <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                              <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.add') }}</b-button>
                            </div>
                          </div>
                        </b-form>
                      </ValidationObserver>
                    </b-overlay>
                  </b-col>
                </b-row>
                <b-overlay :show="loading">
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                    <b-row class="mt-4">
                      <b-col>
                        <table class="table table-bordered">
                          <tr class="bg-light">
                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                            <th>{{ $t('production_store.pro_category') }}</th>
                            <th>{{ $t('production_store.pro_sub_category') }}</th>
                            <th>{{ $t('production_store.pro_name') }}</th>
                            <th>{{ $t('production_store.unit') }}</th>
                            <th>{{ $t('production_store.unit_price') }}</th>
                            <th>{{ $t('production_store.purchase_quantity') }}</th>
                            <th>{{ $t('production_store.total_price') }}</th>
                            <th>{{ $t('globalTrans.action') }}</th>
                          </tr>
                          <tr v-if="formData.per_details.length <= 0">
                            <td colspan="9" class="text-center">{{ $t('globalTrans.noDataFound') }}</td>
                          </tr>
                          <tr v-else v-for="(item, index) in formData.per_details" :key="index">
                              <td>{{ $n(index + 1) }}</td>
                              <td>{{ catNameById(item.category_id) }}</td>
                              <td>{{ subCatNameById(item.sub_category_id) }}</td>
                              <td>{{ productNameById(item.product_id) }}</td>
                              <td>{{ unitNameById(item.unit_id) }}</td>
                              <td>
                                  <ValidationProvider name="Unit price" rules="required">
                                      <b-form-group
                                          slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                          v-model="item.unit_price"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          readonly
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </td>
                              <td>
                                  <ValidationProvider name="Purchase quantity" rules="required">
                                      <b-form-group
                                          slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                          v-model="item.purchase_qty"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          @input="changeQtyFromList(item)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </td>
                              <td>
                                  <ValidationProvider name="Total Price">
                                      <b-form-group
                                          slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                          v-model="item.total_price"
                                          readonly
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                          {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </td>
                              <td>
                                  <button type="button" @click="removeItem(index)" class="btn btn-danger btn-sm">X</button>
                              </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col lg="3" sm="12">
                          <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="fiscal_year_id"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('retailerManagement.fiscal_year')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="formData.fiscal_year_id"
                                :options="fiscalYearList"
                                id="fiscal_year_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      <b-col lg="3" sm="12">
                        <ValidationProvider name="Purchase date" vid="purchase_date" rules="required">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="purchase_date"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                            {{ $t('production_store.purchase_date')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            id="purchase_date"
                            readonly
                            placeholder="Select Date"
                            v-model="formData.purchase_date"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                                  {{ errors[0] }}
                            </div>
                        </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="3" sm="12">
                        <ValidationProvider name="Purchase memo no" vid="memo_no" rules="required">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="memo_no"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                            {{ $t('production_store.purchase_memo_no')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            rows="1"
                            v-model="formData.memo_no"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                        </b-form-group>
                        </ValidationProvider>
                      </b-col>
                        <b-col lg="3" sm="12">
                          <ValidationProvider name="Supplier name" vid="supplier_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="supplier_id"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('production_store.supplier_name')}} <span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                v-model="formData.supplier_id"
                                :options="supplierInfoList"
                                id="supplier_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col lg="3" sm="12">
                          <ValidationProvider name="Company name" vid="company_name">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="company_name"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('production_store.company_name')}}
                              </template>
                              <b-form-input
                                id="company_name"
                                readonly
                                v-model="formData.company_name"
                                :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                    </b-row>
                    <div class="row mt-4">
                      <div class="col-md-12 text-right">
                          <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                          <b-button variant="danger" class="mr-1"><router-link to="raw-material-purchase-manage" :class="'text-light'">{{ $t('globalTrans.cancel') }}</router-link></b-button>
                      </div>
                    </div>
                  </b-form>
                </ValidationObserver>
              </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '../../../../../config/api_config'
import { rawMatPurchaseStore, rawMatPurchaseUpdate, rawMatAvailableStockWithAmount } from '../../api/routes'
import flatpickr from 'flatpickr'
export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      singleProduct: {
        category_id: 0,
        sub_category_id: 0,
        created_date: '',
        unit_id: 0,
        product_id: 0,
        available_quantity: '',
        unit_price: '',
        total_price: '',
        purchase_qty: ''
      },
      old_available_qty: 0,
      formData: {
        per_details: [],
        purchase_date: '',
        fiscal_year_id: 0,
        memo_no: '',
        supplier_id: 0,
        company_name: ''
      },
      subCategoryList: [],
      productList: [],
      unitList: [],
      priceLoad: false,
      loading: false
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    supplierInfoList: function () {
      return this.productCommonObj.supplierInfoList.filter(item => item.status === 0)
    },
    currentLocale: function () {
      return this.$i18n.locale
    },
    salesCenterList: function () {
      return this.productCommonObj.salesCenterList.filter(item => item.status === 1)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    if (this.$route.query.id) {
      const tmp = this.getProductData()
      this.formData = tmp
    }
  },
  mounted () {
    flatpickr('#purchase_date', {})
  },
  watch: {
    'singleProduct.category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.subCategoryList = this.getSubCatList(newVal)
        this.productList = this.getProductListByCat(newVal)
      }
    },
    'singleProduct.sub_category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productList = this.getProductList(newVal)
      }
    },
    'singleProduct.product_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.unitList = this.getUnitList(newVal)
        this.getAvailableStock()
      }
    },
    'singleProduct.unit_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAvailableStock()
      }
    },
    'singleProduct.purchase_qty': function (newVal, oldVal) {
      if (newVal !== oldVal) {
       this.caltulatePriceQty(newVal)
      }
    },
    'formData.supplier_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.formData.company_name = this.supplierCompanyById(newVal)
      }
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.singleProduct.category_id) {
              this.subCategoryList = this.getSubCatList(this.singleProduct.category_id)
              this.productList = this.getProductListByCat(this.singleProduct.category_id)
            }
            if (this.singleProduct.sub_category_id) {
              this.productList = this.getProductList(this.singleProduct.sub_category_id)
              this.unitList = this.getUnitList(this.singleProduct.product_id)
            }
            if (this.singleProduct.product_id) {
              this.unitList = this.getUnitList(this.singleProduct.product_id)
              this.getAvailableStock()
            }
        }
    }
  },
  methods: {
    getProductData () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.$route.query.id))
      const data = JSON.parse(JSON.stringify(tmpData))
      const ferDetails = data.per_details.map(item => {
        return Object.assign(item, item.product)
      })
      return Object.assign(data, ferDetails)
    },
    async saveData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      this.loading = true
      if (this.$route.query.id) {
        result = await RestApi.putData(productionServiceBaseUrl, `${rawMatPurchaseUpdate}/${this.$route.query.id}`, this.formData)
      } else {
        result = await RestApi.postData(productionServiceBaseUrl, rawMatPurchaseStore, this.formData)
      }
      this.loading = false
      loadingState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadingState)

      if (result.success) {
        this.$store.dispatch('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })
        this.$router.push({ path: '/production-service/store-management/raw-material-purchase-manage' })
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    getSubCatList (catId) {
      return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 1)
    },
    getProductListByCat (catId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 1)
    },
    getProductList (subCatId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 1)
    },
    getUnitList (proId) {
      return this.productCommonObj.productUnitList.filter(item => item.product_id === proId && item.status === 1)
    },
    addProduct () {
      const productId = this.singleProduct.product_id
      const unitId = this.singleProduct.unit_id
      const product = this.formData.per_details.find(item => item.product_id === productId && item.unit_id === unitId)
      if (typeof product === 'undefined') {
        this.formData.per_details.push(JSON.parse(JSON.stringify(this.singleProduct)))
        this.blankSingleProduct()
      } else {
        product.purchase_qty = parseInt(product.purchase_qty) + parseInt(this.singleProduct.purchase_qty)
        product.total_price = parseInt(product.total_price) + parseInt(this.singleProduct.total_price)
        this.blankSingleProduct()
      }
      /** This will reset validation error after adding */
      this.$nextTick(() => {
          this.$refs.formAddProduct.reset()
      })
    },
    blankSingleProduct () {
      this.singleProduct.product_id = 0
      this.singleProduct.unit_id = 0
      this.singleProduct.purchase_qty = ''
      this.singleProduct.unit_price = ''
      this.singleProduct.total_price = ''
      this.singleProduct.available_quantity = ''
    },
    removeItem (index) {
      this.formData.per_details.splice(index, 1)
    },
    supplierCompanyById (supplierId) {
      const company = this.productCommonObj.supplierInfoList.find(item => item.value === supplierId)
        if (this.$i18n.locale === 'bn') {
            return company.company_name_bn
        } else {
            return company.company_name
        }
    },
    catNameById (id) {
        const cat = this.productCommonObj.productCategoryList.find(item => item.value === id)
        if (typeof cat === 'undefined') {
          return ''
        } else {
          return cat.text
        }
    },
    subCatNameById (id) {
        const subCat = this.productCommonObj.productSubCategoryList.find(item => item.value === id)
        if (typeof subCat === 'undefined') {
          return ''
        } else {
          return subCat.text
        }
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(item => item.value === id)
        if (typeof product === 'undefined') {
          return ''
        } else {
          return product.text
        }
    },
    unitNameById (id) {
        const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
        if (typeof unit === 'undefined') {
          return ''
        } else {
          return unit.text
        }
    },
    getAvailableStock () {
      const params = {
        product_id: this.singleProduct.product_id,
        unit_id: this.singleProduct.unit_id
      }
      this.priceLoad = true
      RestApi.getData(productionServiceBaseUrl, rawMatAvailableStockWithAmount, params).then(response => {
          if (response.success) {
            this.singleProduct.available_quantity = response.data.stock_quantity
            this.old_available_qty = response.data.stock_quantity
          } else {
            this.singleProduct.available_quantity = 0
            this.old_available_qty = 0
          }

          if (response.priceSuccess) {
            this.singleProduct.unit_price = response.unitPrice.value_price
          } else {
            this.singleProduct.unit_price = 0
          }
          this.singleProduct.purchase_qty = 0
          this.priceLoad = false
      })
    },
    caltulatePriceQty (newVal) {
       const currentQty = parseInt(this.old_available_qty) + parseInt(newVal)
        if (currentQty > 0) {
          this.singleProduct.available_quantity = currentQty
        } else {
           this.singleProduct.available_quantity = this.old_available_qty
        }
        if (parseInt(newVal) > 0) {
          this.singleProduct.total_price = this.singleProduct.unit_price * parseInt(newVal)
        } else {
           this.singleProduct.total_price = 0
        }
    },
    changeQtyFromList (item) {
      item.total_price = item.purchase_qty * item.unit_price
    }
  }
}
</script>
